var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("De pagina waar u naar zoekt bestaat niet")])])}]

export { render, staticRenderFns }